import SupportText from 'presentation/shared/components/SupportText'
import React from 'react'
import * as S from './styles'

type Props = {
  comments: {
    comment: string
    createdAt: Date
  }[]
}

export function AmbulatoryScheduleCommentsHistory({ comments }: Props) {
  return (
    <>
      <SupportText color="primary">Histórico de comentários</SupportText>
      <S.ContainerComments>
        {comments.map((comment, index) => (
          <>
            <div>
              <label>
                {new Intl.DateTimeFormat('pt-BR', {
                  dateStyle: 'long'
                }).format(new Date(comment.createdAt))}
              </label>
              {comment.comment}
            </div>
            {index + 1 === comments.length ? null : <hr />}
          </>
        ))}
      </S.ContainerComments>
    </>
  )
}
